document.addEventListener('DOMContentLoaded', function() {
  /* ========== IMAGE GALLERY ========== */
  const thumbnails = document.querySelectorAll('.pdp-thumbnail');
  const dots = document.querySelectorAll('.pdp-dot');
  const mainImage = document.getElementById('pdp-main-image');

  function updateMainImage(index) {
    const thumbnail = thumbnails[index];
    if (thumbnail) {
      mainImage.src = thumbnail.dataset.imageSrc;
      mainImage.alt = thumbnail.dataset.imageAlt;

      thumbnails.forEach((t, i) => {
        t.classList.toggle('active', i === index);
      });

      dots.forEach((d, i) => {
        d.classList.toggle('active', i === index);
      });
    }
  }

  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', () => {
      updateMainImage(index);
    });
  });

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      updateMainImage(index);
    });
  });

  /* ========== EXPANDABLE BENEFIT CARDS ========== */
  const benefitHeaders = document.querySelectorAll('.pdp-benefit-header');

  benefitHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const card = this.closest('.pdp-benefit-card');
      const content = card.querySelector('.pdp-benefit-content');
      const isActive = card.classList.toggle('active');
      content.style.display = isActive ? 'block' : 'none';
    });
  });

  /* ========== DURATION SELECTOR ========== */
  const durationBtns = document.querySelectorAll('.pdp-duration-btn');
  const checkoutBtn = document.querySelector('.pdp-checkout-btn');

  durationBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      durationBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      const duration = this.dataset.duration;
      const basePrice = parseFloat(checkoutBtn.dataset.basePrice);
      const totalPrice = (basePrice * duration).toFixed(2);

      checkoutBtn.textContent = 'CHECKOUT NOW \u2014 $' + totalPrice;
    });
  });

  /* ========== REVIEW CAROUSEL ========== */
  const reviewCards = document.querySelectorAll('.pdp-review-card');
  const prevBtn = document.querySelector('.pdp-prev-arrow');
  const nextBtn = document.querySelector('.pdp-next-arrow');
  let currentReviewIndex = 0;

  function showReviews(startIndex) {
    reviewCards.forEach((card, index) => {
      card.style.display =
        index >= startIndex && index < startIndex + 3 ? 'flex' : 'none';
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      currentReviewIndex = Math.max(0, currentReviewIndex - 1);
      showReviews(currentReviewIndex);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      currentReviewIndex = Math.min(
        reviewCards.length - 3,
        currentReviewIndex + 1
      );
      showReviews(currentReviewIndex);
    });
  }

  showReviews(0);

  /* ========== QUESTION PILLS ========== */
  const questionPills = document.querySelectorAll('.pdp-question-pill');
  const formulaInput = document.querySelector('.pdp-formulaai-input');

  questionPills.forEach(pill => {
    pill.addEventListener('click', function() {
      formulaInput.value = this.textContent;
      formulaInput.focus();
    });
  });
});
